export const ReactSelectStyle = {
    control: (provided, state) => {
        if (state.selectProps.className === "is-invalid") {
            return {
                ...provided,
                backgroundColor: "transparent",
                border: 0,
                borderBottom: '1px solid red',
                borderRadius: '0rem',
                borderColor: state.isFocused ? "#9c5b4b" : '#dc3545',
                boxShadow: state.isFocused ? "0 0 0 0.25rem rgb(156 91 75 / 25%)" : 'initial',
                ':hover': {
                    borderColor: '#dc3545'
                }
            };
        }
        else {
            return {
                ...provided,
                backgroundColor: "transparent",
                border: 0,
                borderBottom: '1px solid #9c5b4b',
                borderRadius: '0rem',
                borderColor: state.isFocused ? '#9c5b4b' : '#ced4da',
                boxShadow: state.isFocused ? "0 0 0 0.25rem rgb(156 91 75 / 25%)" : "intial",
                ':hover': {
                    borderColor: state.isFocused ? '#9c5b4b' : '#ced4da',
                }
            };
        }
    },
    indicatorSeparator: (provided, state) => {
        return state.selectProps.className === "is-invalid" ? {
            ...provided,
            width: "calc(0.75em + .375rem)",
            height: "calc(0.75em + .375rem)",
            backgroundColor: "transparent",
            backgroundSize: "calc(0.75em + .375rem) calc(.75em + 0.375rem)",
            backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\")"
        } : {}
    },
    option: (provided, state) => {
        return {
            ...provided,
            backgroundColor: state.isSelected ? "#9c5b4b" : state.isFocused ? "rgb(156 91 75 / 25%)" : undefined,
            ':active': {
                ...provided[':active'],
                backgroundColor: "rgb(156 91 75 / 50%)",
            },
        }
    },
    clearIndicator: (provided, state) => {
        return {
            ...provided,
            position: "absolute",
            marginLeft: "-20px",
        }
    }
}